import { render, staticRenderFns } from "./ApplicationsWatcherPage.vue?vue&type=template&id=4fa6caff&scoped=true&v-if=this.user.loggedIn"
import script from "./ApplicationsWatcherPage.vue?vue&type=script&lang=js"
export * from "./ApplicationsWatcherPage.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsWatcherPage.vue?vue&type=style&index=0&id=4fa6caff&prod&scoped=true&lang=css"
import style1 from "./ApplicationsWatcherPage.vue?vue&type=style&index=1&id=4fa6caff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6caff",
  null
  
)

export default component.exports